import type { NuxtApp } from '#app'
import {getStampinupApiDomain} from '~/utils/locale'
import {useLocaleStore} from '~/stores/locale'
import {fetchInit} from '~/composables/api'
import { useTypedRuntimeConfig } from '~/utils/runtimeConfig'


export default defineNuxtPlugin({
    name: 'api-reports',
    async setup(nuxtApp) {
        const $config = useTypedRuntimeConfig()
        const localeStore = useLocaleStore()

        const baseUrl = `${getStampinupApiDomain($config.public.API_PREFIX, localeStore.culture)}/reportsgateway`

        const $api = fetchInit(nuxtApp as NuxtApp, baseUrl)

        return {
            provide: {
              reportsApi: $api
            }
        }
    }
})